import type { ReactNode } from "react";
import { Fragment } from "react";
import { t } from "@/i18n-js/instance";
import { useMemberFilterDesign } from "@/react/components/shared/FilterV3/MemberFilterDesignContext";
import { Icon } from "@circle-react-shared/Icon";
import type { PopperOptions } from "@circle-react-uikit/Dropdown";
import { DROPDOWN_SIZE, Dropdown } from "@circle-react-uikit/Dropdown";
import { Typography } from "@circle-react-uikit/Typography";

interface AddFilterDropdownProps {
  children: ReactNode;
  label?: string;
  popperOptions?: PopperOptions;
}

export const AddFilterDropdown = ({
  children,
  label = t("settings.manage_members.add_filter"),
  popperOptions = {},
}: AddFilterDropdownProps) => {
  const isMemberFilterDesignEnabled = useMemberFilterDesign();

  return (
    <Dropdown
      direction="bottom-start"
      dataTestId="add-filter-dropdown"
      as={Fragment}
      buttonWrapperComponent="li"
      size={DROPDOWN_SIZE.EXTRA_LARGE}
      buttonClassName={
        isMemberFilterDesignEnabled
          ? "!size-8 p-2 bg-primary border hover:border-secondary !rounded-full inline-flex justify-start items-center gap-2 hover:bg-secondary focus-visible:bg-secondary disabled:cursor-not-allowed disabled:opacity-40"
          : "hover:border-secondary focus-visible:border-secondary !rounded-3xl disabled:hover:border-primary border flex h-6 justify-center items-center hover:bg-secondary focus-visible:bg-secondary gap-0.5 disabled:cursor-not-allowed disabled:opacity-40 pl-1"
      }
      popperOptions={popperOptions}
      button={
        isMemberFilterDesignEnabled ? (
          <Icon type="16-add" size={16} aria-hidden className="text-darkest" />
        ) : (
          <>
            <Icon
              type="20-add-sm"
              size={20}
              aria-hidden
              className="text-darkest"
            />
            <Typography.LabelXs weight="medium">
              <span className="text-darkest pr-2">{label}</span>
            </Typography.LabelXs>
          </>
        )
      }
    >
      {children}
    </Dropdown>
  );
};
